import { render } from "./SessionCard.vue?vue&type=template&id=ff406cd4&scoped=true"
import script from "./SessionCard.vue?vue&type=script&lang=js"
export * from "./SessionCard.vue?vue&type=script&lang=js"

import "./SessionCard.vue?vue&type=style&index=0&id=ff406cd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff406cd4"]])

export default __exports__